import Vue from "vue";
import VueRouter from "vue-router";
import MainComp from "./js/components/MainCmp.vue";
import ClientOnlineComp from "./js/components/wlmz/clinicOnLine.vue";
import Login from './js/views/Login.vue'
Vue.use(VueRouter);
export default new VueRouter({
    routes: [
        { path: "/", redirect: "/login" },
        {
            path: "/login",
            component: Login
        },
        {
            path: "/register",
            component: () =>
                import ("./js/components/Register.vue")
        }, //注册页路由
        {
            //修改密码页路由
            path: "/password",
            component: () =>
                import ("./js/components/Password.vue"),
            children: [{
                    path: "",
                    component: () =>
                        import ("./js/components/PwdStep1Cmp.vue")
                },
                {
                    path: "step2",
                    component: () =>
                        import ("./js/components/PwdStep2Cmp.vue")
                },
                {
                    path: "step3",
                    component: () =>
                        import ("./js/components/PwdStep3Cmp.vue")
                }
            ]
        },
        {
            //设置页路由
            path: "/setUp",
            component: () =>
                import ("./js/components/setting/SetUp.vue"),
            children: [{
                    path: "",
                    component: () =>
                        import ("./js/components/setting/SetUpMyInfo.vue")
                },
                {
                    path: "changePwd",
                    component: () =>
                        import ("./js/components/setting/SetUpChangePwd.vue")
                },
                {
                    path: "businessSetting",
                    component: () =>
                        import ("./js/components/setting/SetUpBusinessSetting.vue")
                }, //业务设置
                {
                    path: "bindPhone",
                    component: () =>
                        import ("./js/components/setting/SetUpBindPhone.vue")
                }, //绑定手机
                {
                    path: "income",
                    component: () =>
                        import ("./js/components/setting/SetUpIncome.vue")
                }, //我的收入
                {
                    path: "card",
                    component: () =>
                        import ("./js/components/setting/SetUpMyCard.vue")
                }, //我的名片
                {
                    path: "avatar",
                    component: () =>
                        import ("./js/components/setting/SetUpMyAvatar.vue")
                }, //我的头像
                {
                    path: "yhInfo",
                    component: () =>
                        import ("./js/components/setting/SetUpYHInfo.vue")
                }, //我的头像
                {
                    path: "inyanzheng",
                    component: () =>
                        import ("./js/components/setting/SetUpYZ.vue")
                }, //我的收入
                {
                    path: "myreport",
                    component: () =>
                        import ("./js/components/setting/SetUpMyReport.vue")
                }, //我的头像
            ]
        },
        {
            //主界面路由
            path: "/main",
            component: MainComp,
            children: [{
                    path: "",
                    name: "clinicOnLine",
                    component: ClientOnlineComp
                }, //网络门诊
                {
                    path: "ClinicDetail",
                    name: "ClinicDetail",
                    component: () =>
                        import ("./js/components/wlmz/ClinicDetail.vue")
                },
                {
                    path: "ClinicDetailPrescription",
                    name: "ClinicDetailPrescription",
                    component: () =>
                        import ("./js/components/wlmz/ClinicDetailPrescription.vue")
                },
                {
                    path: "clinicOnLine/print/:consultId",
                    name: "clinicOnLinePrintRemoteSheet",
                    component: () =>
                        import ("./js/components/wlmz/PrintView.vue")
                }, // 打印

                /*远程会诊*/
                {
                    path: "remoteConsultation",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsultation.vue")
                },
                {
                    path: "remoteConsultation/sheet/:consultId",
                    name: "remoteSheet",
                    component: () =>
                        import ("./js/components/ychz/ConsultationSheet.vue")
                },
                {
                    //远程会诊待处理
                    path: "remoteConsultation/toDeal"
                },
                {
                    //远程会诊我发起的
                    path: "remoteConsultation/toDeal",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsultationDoDeal.vue"),
                    children: [{
                        path: ":consultId",
                        name: "remoteToDeal",
                        component: () =>
                            import ("./js/components/ychz/RemoteConsultationDealView.vue")
                    }]
                },
                {
                    //医院医助进入的远程会诊
                    path: "RemoteConsulations",
                    name: "RemoteConsulations",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsulations.vue")
                },
                {
                    path: "remoteConsultation/launch",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsultationLaunch.vue")
                },
                {
                    path: "remoteConsultation/reject/:consultId",
                    name: "remoteReject",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsultationReject.vue")
                },
                {
                    path: "remoteConsultation/evaluate/:consultId",
                    name: "remoteEvaluate",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsultationEvaluate.vue"),
                    children: [{
                        path: "showClassList",
                        name: "showClassList",
                        component: () =>
                            import ("./js/components/ychz/showClassList.vue")
                    }]
                },
                {
                    path: "remoteConsultation/print/:consultId",
                    name: "printRemoteSheet",
                    component: () =>
                        import ("./js/components/wlmz/PrintView.vue")
                }, // 打印
                {
                    path: "remoteConsultation/entryVideo/:consultId",
                    name: "remoteEntry",
                    component: () =>
                        import ("./js/components/ychz/RemoteConsultationEntryView.vue"),
                    children: [{
                        path: "showClassListS",
                        name: "showClassListS",
                        component: () =>
                            import ("./js/components/ychz/showClassList1.vue")
                    }]
                },
                {
                    path: "management-contract",
                    component: () =>
                        import ("./js/views/patient-signing/ManagementContract.vue")
                },
                {
                    path: "management-contract-details",
                    component: () =>
                        import ("./js/views/patient-signing/ManagementContractDetails.vue")
                },
                {
                    path: "management-service-reservation",
                    component: () =>
                        import (
                            "./js/views/patient-signing/ManagementServiceReservation.vue"
                        )
                },
                //患者查询
                {
                    path: "patientQuery",
                    component: () =>
                        import ("./js/views/PatientInquiry/patientQuery.vue")
                },
                //质控 2023年8月28日
                {
                    path: "quality-control",
                    component: () =>
                        import ("./js/views/quality-control/quality-control.vue")
                },
                //质控详情 2023年8月28日
                {
                    path: "quality-control-detail",
                    component: () =>
                        import ("./js/views/quality-control/quality-control-detail.vue")
                },
                {
                    path: "pharmacy-workstation",
                    component: () =>
                        import ("./js/views/pharmacy-workstation/list.vue")
                },
                {
                    path: "pharmacy-drugs",
                    component: () =>
                        import ("./js/views/pharmacy-drugs/list.vue")
                },
                {
                    path: "e-prescription",
                    component: () =>
                        import ("./js/views/prescription-management/EPrescription")
                },
                {
                    path: "prescription-list",
                    component: () =>
                        import ("./js/views/prescription-management/PrescriptionList")
                },
                {
                    path: "prescription-check",
                    component: () =>
                        import ("./js/views/prescription-management/PrescriptionCheck")
                },
                //病历处方
                {
                    path: "Report",
                    component: () =>
                        import ("./js/views/PatientInquiry/section.vue")
                },

                {
                    path: "prescriptionDetails",
                    component: () =>
                        import ("./js/views/PatientInquiry/prescriptionDetails")
                },
                {
                    path: "medicalList",
                    component: () =>
                        import ("./js/views/PatientInquiry/medicalList")
                },
                {
                    path: "medicalListDetails",
                    component: () =>
                        import ("./js/views/PatientInquiry/medicalListDetails")
                },
                {
                    path: "seeData",
                    component: () =>
                        import ("./js/views/PatientInquiry/Report.vue")
                },
                //开处方
                {
                    path: "Prescribing",
                    component: () =>
                        import ("./js/views/Prescribing/Prescribing")
                },
                {
                    path: "operation",
                    component: () =>
                        import ("./js/views/Prescribing/operation")
                },
                //病历模板管理
                {
                    path: "medicalTemplateList",
                    component: () =>
                        import ("./js/views/medicalTemplate/medicalTemplateList")
                },
                {
                    path: "addMedicalTemplate",
                    component: () =>
                        import ("./js/views/medicalTemplate/addMedicalTemplate")
                },
                //健康管理
                {
                    path: 'memberList',
                    component: () =>
                        import ('./js/views/healthManagement/memberList')
                },
                {
                    path: 'programmeList',
                    component: () =>
                        import ('./js/views/healthManagement/programmeList')
                },
                {
                    path: 'addProgramme',
                    component: () =>
                        import ('./js/views/healthManagement/addProgramme')
                },
                {
                    path: 'healthyProgramme',
                    component: () =>
                        import ('./js/views/healthyProgramme/healthyProgramme')
                },
                {
                    path: 'healthyProgrammeList',
                    component: () =>
                        import ('./js/views/healthyProgramme/healthyProgrammeList')
                },
                {
                    path: 'programmeAdd',
                    component: () =>
                        import ('./js/views/healthyProgramme/programmeAdd')
                },
                {
                    path: 'questionnaireList',
                    component: () =>
                        import ('./js/views/questionnaireList/questionnaireList')
                },
                {
                    path: 'questionnaireAnswer',
                    component: () =>
                        import ('./js/views/questionnaireList/questionnaireAnswer')
                },
                {
                    path: 'questionnaireDetails',
                    component: () =>
                        import ('./js/views/questionnaireList/questionnaireDetails')
                },
                {
                    path: "PrescriptionDetailed",
                    component: () =>
                        import ("./js/views/prescription-management/PrescriptionDetailed")
                },
                //网络病历
                {
                    path: "medicalRecord",
                    component: () =>
                        import ("./js/views/medicalRecord/medicalRecordList")
                },
                {
                    path: "editMedicalRecord",
                    component: () =>
                        import ("./js/views/medicalRecord/editMedicalRecord")
                }
            ]
        },
        {
            path: '/other/single/chat',
            component: () =>
                import ('./js/views/other/single/chat')
        },

        {
            path: "e-prescription",
            component: () =>
                import ("./js/views/prescription-management/EPrescription")
        },
    ]
});

// export const dynamicRoutes = [
//   {
//     //主界面路由
//     path: "/main",
//     component: MainComp,
//     children: [
//       {
//         path: "",
//         name: "clinicOnLine",
//         component: ClientOnlineComp
//       }, //网络门诊
//       {
//         path: "ClinicDetail",
//         name: "ClinicDetail",
//         component: () => import("./js/components/wlmz/ClinicDetail.vue")
//       },
//       {
//         path: "clinicOnLine/print/:consultId",
//         name: "clinicOnLinePrintRemoteSheet",
//         component: () => import("./js/components/wlmz/PrintView.vue")
//       }, // 打印

//       /*远程会诊*/
//       {
//         path: "remoteConsultation",
//         component: () => import("./js/components/ychz/RemoteConsultation.vue")
//       },
//       {
//         path: "remoteConsultation/sheet/:consultId",
//         name: "remoteSheet",
//         component: () => import("./js/components/ychz/ConsultationSheet.vue")
//       },
//       {
//         //远程会诊待处理
//         path: "remoteConsultation/toDeal"
//       },
//       {
//         //远程会诊我发起的
//         path: "remoteConsultation/toDeal",
//         component: () =>
//           import("./js/components/ychz/RemoteConsultationDoDeal.vue"),
//         children: [
//           {
//             path: ":consultId",
//             name: "remoteToDeal",
//             component: () =>
//               import("./js/components/ychz/RemoteConsultationDealView.vue")
//           }
//         ]
//       },
//       {
//         //医院医助进入的远程会诊
//         path: "RemoteConsulations",
//         name: "RemoteConsulations",
//         component: () => import("./js/components/ychz/RemoteConsulations.vue")
//       },
//       {
//         path: "remoteConsultation/launch",
//         component: () =>
//           import("./js/components/ychz/RemoteConsultationLaunch.vue")
//       },
//       {
//         path: "remoteConsultation/reject/:consultId",
//         name: "remoteReject",
//         component: () =>
//           import("./js/components/ychz/RemoteConsultationReject.vue")
//       },
//       {
//         path: "remoteConsultation/evaluate/:consultId",
//         name: "remoteEvaluate",
//         component: () =>
//           import("./js/components/ychz/RemoteConsultationEvaluate.vue"),
//         children: [
//           {
//             path: "showClassList",
//             name: "showClassList",
//             component: () => import("./js/components/ychz/showClassList.vue")
//           }
//         ]
//       },
//       {
//         path: "remoteConsultation/print/:consultId",
//         name: "printRemoteSheet",
//         component: () => import("./js/components/wlmz/PrintView.vue")
//       }, // 打印
//       {
//         path: "remoteConsultation/entryVideo/:consultId",
//         name: "remoteEntry",
//         component: () =>
//           import("./js/components/ychz/RemoteConsultationEntryView.vue"),
//         children: [
//           {
//             path: "showClassListS",
//             name: "showClassListS",
//             component: () => import("./js/components/ychz/showClassList1.vue")
//           }
//         ]
//       },
//       {
//         path: "management-contract",
//         component: () =>
//           import("./js/views/patient-signing/ManagementContract.vue")
//       },
//       {
//         path: "management-contract-details",
//         component: () =>
//           import("./js/views/patient-signing/ManagementContractDetails.vue")
//       },
//       {
//         path: "management-service-reservation",
//         component: () =>
//           import("./js/views/patient-signing/ManagementServiceReservation.vue")
//       },
//       {
//         path: "pharmacy-workstation",
//         component: () => import("./js/views/pharmacy-workstation/list.vue")
//       },
//       {
//         path: "pharmacy-drugs",
//         component: () => import("./js/views/pharmacy-drugs/list.vue")
//       },

//     ]
//   }
// ];